module.exports = __webpack_public_path__ + "img/logo.0deda4a4.png";